import { forwardRef, ForwardRefFn } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

// this function is duplicated in src/app/shared/utils/value-accessor.utils.ts
export const provideValueAccessor = (componentFactory: ForwardRefFn) => ({
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(componentFactory),
  multi: true,
});
